import { FC } from 'react';

import { ArticleLayoutIdsProvider } from './article-layout-ids';

export const BlogProvider: FC = ({ children }) => (
  <ArticleLayoutIdsProvider>{children}</ArticleLayoutIdsProvider>
);
